import { useEffect, useState } from "react";
import { getLayerLegend } from "./singleLayerService";
import { getColorMapIsCategoricalByName } from "../core/colorMapService";
import { getLegendFooterDescription, getLegendHeaderDescription, getLegendValueDescription } from "./legendService";
import { Typography } from "antd";
import Parser from "html-react-parser";
import { set } from "ol/transform";

const { Text, Link } = Typography;

export function SingleLayerSettingsHelpContent({
    data,
    colorMapName,
    isH3
}) {
    const [legend, setLegend] = useState([]);
    const [headerDescription, setHeaderDescription] = useState("");
    const [footerDescription, setFooterDescription] = useState("");
    const [valueDescription, setValueDescription] = useState([]);
    const [isVectorContinuous, setIsVectorContinuous] = useState(undefined);
    const [isRasterContinuous, setIsRasterContinuous] = useState(undefined);
    const [isRasterCategorical, setIsRasterCategorical] = useState(undefined);
    const [isVectorCategorical, setIsVectorCategorical] = useState(undefined);



    function getGradientBackground(data) {
        const percent = parseInt(100 / (data.length - 1), 10);

        return "linear-gradient(180deg, " + data.map((item, idx) => {
            return ` ${item['color']} ${percent * idx}%`
        }) + ")"
    }

    useEffect(() => {
        const layer = `${data['geoserver_workspace']}:${data['geoserver_layer_name']}`
        const nameLayer = data['is_time'] ? data['geoserver_layer_name'].split('_')[0] : data['geoserver_layer_name'];
        const colorMap = `${data['geoserver_workspace']}:${nameLayer}-${colorMapName}`
        const vectorContinuous = !data['is_raster'] && (
            isH3 ||
            data['geoserver_layer_name'] === 'commuting-admins-indonesia' ||
            data['geoserver_layer_name'] === 'accessibility-buildings-sumatra' ||
            data['geoserver_layer_name'] === 'urban-heat-islands-indonesia' ||
            data['geoserver_layer_name'] === 'urban-heat-islands-day-indonesia' ||
            (data['geoserver_layer_name'] === 'roads-sumatra' && data['composite_layer'] !== 'StreetCategoryLayer')
        ) ||
            (data['geoserver_layer_name'] === 'ps-indonesia')
        const rasterContinuous = data['is_raster'] && !getColorMapIsCategoricalByName(colorMapName) &&
            data['geoserver_layer_name'] !== 'ps-indonesia'
        const rasterCategorical = data['is_raster'] && !rasterContinuous &&
            data['geoserver_layer_name'] !== 'ps-indonesia'
        const vectorCategorical = !data['is_raster'] && !vectorContinuous
        setIsVectorContinuous(vectorContinuous)
        setIsRasterContinuous(rasterContinuous)
        setIsRasterCategorical(rasterCategorical)
        setIsVectorCategorical(vectorCategorical)
        //console.log('isVectorContinuous', isVectorContinuous)
        //console.log('isRasterContinuous', isRasterContinuous)
        //console.log('isRasterCategorical', isRasterCategorical)
        //console.log('isVectorCategorical', isVectorCategorical)

        if (rasterCategorical || rasterContinuous) {
            getLayerLegend(layer, colorMap).then((response) => {
                try {
                    setLegend(response.data['Legend'][0].rules[0]['symbolizers'][0]['Raster']['colormap'].entries)
                } catch (e) {
                    setLegend([])
                }
            })
        }

        if (vectorContinuous) {
            getLegendValueDescription(data.id).then((response) => {
                if (response) {
                    const data = response.data;
                    const h3legend = []
                    data.map((item, idx) => { h3legend.push({ label: item.description, quantity: item.value, color: item.color_hex }) })
                    setLegend(h3legend)
                }
            })
        }

        getLegendHeaderDescription(data.id).then((response) => {
            if (response) {
                const data = response.data;
                setHeaderDescription(data.description);
            }
        })

        getLegendFooterDescription(data.id).then((response) => {
            if (response) {
                const data = response.data;
                setFooterDescription(data.description);
            }
        })

        if (rasterCategorical || vectorCategorical || rasterContinuous) {
            getLegendValueDescription(data.id).then((response) => {
                if (response) {
                    const data = response.data;
                    setValueDescription(data)
                }
            });
        } else {
            setValueDescription([])
        }

    }, [data, colorMapName]);

    return (
        <>
            {headerDescription &&
                <Text type="secondary" style={{ display: 'block', marginBottom: 10 }}>{headerDescription}</Text>}
            {isRasterCategorical && legend.map((item, idx) => <div
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
                key={idx}>
                <div style={{
                    width: '20px',
                    height: '20px',
                    backgroundColor: item['color'],
                    borderRadius: 5,
                }}></div>
                <span style={{
                    fontFamily: 'SpaceMonoRegular',
                    fontSize: '13px',
                    padding: '5px 10px'
                }}

                >{item['label']} <span style={{ color: '#7b7b7b' }}>{valueDescription[idx]?.description}</span></span>
            </div>)}
            {(isRasterContinuous || isVectorContinuous) && <div
                style={{
                    display: 'flex',
                    margin: 5
                }}>
                <div
                    style={{
                        width: 20,
                        // height: '100px',
                        border: '1px solid #e8e8e8',
                        borderRadius: 5,
                        background: getGradientBackground(legend)
                    }}></div>
                <div>
                    {legend.map((item, idx) => <div key={idx}>
                        <span style={{
                            fontFamily: 'SpaceMonoRegular',
                            fontSize: '13px',
                            padding: '5px 10px'
                        }}

                        >{item['label']}</span></div>)}
                </div>
                <div>
                    {valueDescription.map((item, idx) =>
                        <span style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontFamily: 'SpaceMonoRegular',
                            fontSize: '13px',
                        }}

                        ><span style={{ color: '#7b7b7b' }}>{item.description}</span></span>)}
                </div>
            </div>}
            {isVectorCategorical && valueDescription.map((item, idx) => <div
                style={{
                    display: 'flex',
                    alignItems: 'center'
                }}
                key={idx}>
                <div style={{
                    width: '20px',
                    height: '20px',
                    backgroundColor: item['color_hex'],
                    borderRadius: 5,
                }}></div>
                <span style={{
                    fontFamily: 'SpaceMonoRegular',
                    fontSize: '13px',
                    padding: '5px 10px'
                }}

                ><span style={{ color: '#7b7b7b' }}>{item.description}</span></span>
            </div>)}
            {footerDescription &&
                <Text type="secondary" style={{
                    display: 'block',
                    fontSize: '0.7em',
                    marginTop: 10
                }}>{Parser(footerDescription)}</Text>}
        </>
    )
}
